<template>
    <div class="form section-c dealer-form" style="position: relative;">
        <div class="section-subhead">
            <i v-if="locked" class="fa fa-lock" style="padding: 0 0.25em 0 0; cursor: pointer;" @click="showLockedReason()"></i>
			Section C - ATF Info (2023)
        </div>
        <div class="section-c-detail">

			<div class="section-c-section one-two-columns">
				<div>
					<h2 ref="customer_trans_purpose" class="small">Category of firearm(s) to be transferred<br>(select all that apply):</h2>
					<checkbox v-model="form.form_data.section_c.customer_trans_purpose.l1" label="Handgun" style="margin: 0.5em 0;"/>
					<checkbox v-model="form.form_data.section_c.customer_trans_purpose.l2" label="Long Gun (i.e., rifle or shotgun)" style="margin: 0.5em 0;"/>
					<checkbox v-model="form.form_data.section_c.customer_trans_purpose.l3" label="Other Firearm (e.g., frame, receiver, etc.)" style="margin: 0.5em 0;"/>
				</div>
				<div>
					<h2 class="small">If sale or transfer is at a qualifying gun show or event:</h2>
					<div class="three-columns">
					<div>
						<label ref="gun_show_name">Name of Function</label>
						<input type="text" v-model="form.form_data.section_c.gun_show_name"/>
					</div>
					<div>
						<label ref="gun_show_county">County</label>
						<input type="text" v-model="form.form_data.section_c.gun_show_county"/>
					</div>
					<div>
						<label ref="gun_show_address">Address</label>
						<input type="text" v-model="form.form_data.section_c.gun_show_address"/>
					</div>
					<div>
						<label ref="gun_show_city">City</label>
						<input type="text" v-model="form.form_data.section_c.gun_show_city"/>
					</div>
					<div>
						<label ref="gun_show_state">State</label>
						<input type="text" v-model="form.form_data.section_c.gun_show_state"/>
					</div>
					<div>
						<label ref="gun_show_zip_code">ZIP Code</label>
						<input type="text" v-model="form.form_data.section_c.gun_show_zip_code"/>
					</div>
				</div>
				</div>
			</div>

			<h2 class="small">Identification</h2>
			<div class="section-c-section two-columns align-items-start">
				<div>
					<label ref="buyer_identification_issuing_authority_and_type">Issuing Authority</label>
					<input type="text" v-model="form.form_data.section_c.buyer_identification_issuing_authority_and_type"/>
				</div>
				<div>
					<label ref="buyer_identification_type_code">Type of Identfication</label>
					<select v-model="form.form_data.section_c.buyer_identification_type_code">
						<option value="" title="DefaultDropDownValue">Select...</option>
						<option value="AF">Air Force Serial Number</option>
						<option value="AR">Alien Registration Number or USCIS</option>
						<option value="AS">Army Serial Number, National Guard Serial Number or Air National Guard Serial Number, regardless of State</option>
						<option value="CI">Canadian Social Insurance Number</option>
						<option value="DL">Driver's License Number - State Issued Identification Card</option>
						<option value="SID">State Id Card Number - Non-DL State Issued Identification Card</option>
						<option value="FN">Fingerprint Identification Number</option>
						<option value="MC">Marine Corps Serial Number</option>
						<option value="MD">Mariner's Document or Identification Number</option>
						<option value="NS">Navy Serial Number</option>
						<option value="I9">Non-Immigrant Admissions Number</option>
						<option value="OA">Other Agency Id</option>
						<option value="PP">Passport Number</option>
						<option value="PI">Personal Identification Number (this applies only to state-issued numbers)</option>
						<option value="PS">Port Security Card Number</option>
						<option value="MP">Royal Canadian Mounted Police Identification Number</option>
						<option value="SS">Selective Service Number</option>
						<option value="CG">U.S. Coast Guard Number</option>
						<option value="VA">Veterans Administration Claim Number</option>
					</select>
					<div v-if="form.form_data.section_c.buyer_identification_type_code == 'OA'">
						<label ref="buyer_identification_type_description">ID description, e.g. 'State Firearm License'</label>
						<input type="text" v-model="form.form_data.section_c.buyer_identification_type_description">
					</div>
				</div>
				<div>
					<label ref="buyer_identification_number">Number on Identification</label>
					<input type="text" v-model="form.form_data.section_c.buyer_identification_number"/>
				</div>
				<div>
					<label ref="buyer_identification_expiration_date">Expiration Date of Identification (if any)</label>
					<date-input v-model="form.form_data.section_c.buyer_identification_expiration_date" style="max-width: 13em;" :allowFuture="true" :warnPast="true" />
				</div>
			</div>

			<div class="two-columns">
				<div>
					<label ref="buyer_supplemental_government_documentation">Supplemental Government Issued Documentation</label>
					<input type="text" v-model="form.form_data.section_c.buyer_supplemental_government_documentation"/>
				</div>
			</div>

			<h2 class="small">Official Military Orders Establishing Permanent Change of Station (PCS)</h2>
			<div class="section-c-section three-columns">
				<div>
					<label ref="permanent_change_of_station_city_state">PCS Base, City and State</label>
					<input type="text" v-model="form.form_data.section_c.permanent_change_of_station_city_state"/>
				</div>
				<div>
					<label ref="permanent_change_of_station_effective_date">PCS Effective Date</label>
					<date-input v-model="form.form_data.section_c.permanent_change_of_station_effective_date" style="max-width: 13em;" />
				</div>
				<div>
					<label ref="permanent_change_of_station_order_number">PCS Order Number (if any)</label>
					<input type="text" v-model="form.form_data.section_c.permanent_change_of_station_order_number"/>
				</div>
			</div>
			
			<div class="section-c-section two-one-columns">
				<label ref="exception_to_the_nonimmigrant_alien_prohibition_documentation">
					Exception to the Nonimmigrant Alien Prohibition: If the transferee/buyer answered “yes” to <b>Section B, question <span class="firearm-line-number">m2</span></b> <i>If you are such an alien do you fall within any of the exceptions stated in the instructions?</i>, record the type of documentation showing the exception to the prohibition and attach a copy to this ATF Form 4473:<br>
					(Transferee/Buyer answered <b>“{{ form.form_data.section_b.exc_code ? form.form_data.section_b.exc_code : 'Not Applicable' }}“</b>)
				</label>
				<input type="text" v-model="form.form_data.section_c.exception_to_the_nonimmigrant_alien_prohibition_documentation"/>
			</div>

			<h2 class="small" ref="nics_check">Complete NICS Check</h2>
			<div class="section-c-section two-columns">
				<div :class="['button', !readyForNICSCheck ? 'disabled' : 'action']" @click="nicsOnlineCheck = readyForNICSCheck">NICS ONLINE CHECK</div>
				<div :class="['button', !readyForNICSCheck ? 'disabled' : 'action']" @click="nicsPhoneCheck = readyForNICSCheck">NICS PHONE CHECK</div>
			</div>
			<div v-if="!readyForNICSCheck" style="margin: 0 0 1em 0; border: 1px solid #ccc; padding: 0.5em;">
				Enter the Identification Issuing Authority, Type of Identification, and Number on Identification before doing a NICS Check.
			</div>
			<div class="section-c-section two-columns">
				<div>
					<label ref="nics_initial_response_date">Date the transferee’s/buyer’s identifying information in Section B was transmitted to NICS or the appropriate State agency</label>
					<input type="date" v-model="form.form_data.section_c.nics_initial_response_date" :max="today" style="max-width: 13em;" />
				</div>
				<div>
					<label ref="nics_number">The NICS or State transaction number (if provided) was</label>
					<div class="two-one-columns">
						<input type="text" v-model="form.nics_number"/>
						<checkbox v-model="form.form_data.section_c.no_nics_number_provided" label="Number not provided" style="margin: 0.5em 0;"/>
					</div>
				</div>
			</div>

			<h2 class="small" ref="nics_initial_response">The response initially provided by NICS or the appropriate State agency was:</h2>
			<div class="section-c-section two-columns">
				<div style="margin: 0.5em 0 0 0;">
					<binary-toggle v-model="form.form_data.section_c.nics_initial_response" :rondo="true" :values="isLegacyData ? 'Proceed,Denied,Cancelled,Delayed' : 'Proceed,Denied,Canceled,Delayed'" :labels="isLegacyData ? 'Proceed,Denied,Cancelled,Delayed' : 'Proceed,Denied,Canceled,Delayed'" :key="'ir_' + form.form_data.section_c.nics_initial_response"/>
				</div>
				<div v-show="form.form_data.section_c.nics_initial_response == 'Delayed'" class="two-columns" style="margin: 0.5em 0 0 0;">
					<label ref="nics_firearm_may_be_transferred">The firearm(s) may be transferred on this date if time period is not extended by NICS or the appropriate State agency, and State law allows (optional).</label>
					<div class="two-columns">
						<input type="date" v-model="form.form_data.section_c.nics_firearm_may_be_transferred" style="max-width: 13em;" />
						<checkbox v-if="!form.form_data.section_c.nics_firearm_may_be_transferred" v-model="acceptDelayedDateSectionC" label="Check to add delayed date" style="margin: 0.5em 0;"/>
					</div>
				</div>
			</div>

			<h2 class="small">Prior to transfer the following response(s) was/were later provided by NICS or the appropriate State agency:</h2>
			<div class="section-c-section four-columns" style="align-items: start;">
				<div>
					<checkbox label="Proceed" style="margin: 0.5em 0;" v-model="form.form_data.section_c.nics_later_response_proceed"/>
					<input v-show="form.form_data.section_c.nics_later_response_proceed" type="date" v-model="form.form_data.section_c.nics_later_response_proceed_date" style="max-width: 13em;" />
				</div>
				<div>
					<checkbox label="Denied" style="margin: 0.5em 0;" v-model="form.form_data.section_c.nics_later_response_denied"/>
					<input v-show="form.form_data.section_c.nics_later_response_denied" type="date" v-model="form.form_data.section_c.nics_later_response_denied_date" style="max-width: 13em;" />
				</div>
				<!-- support legacy property nics_later_response_cancelled -->
				<div v-if="form.form_data.section_c.nics_later_response_cancelled">
					<checkbox label="Cancelled" style="margin: 0.5em 0;" v-model="form.form_data.section_c.nics_later_response_cancelled"/>
					<input v-show="form.form_data.section_c.nics_later_response_cancelled" type="date" v-model="form.form_data.section_c.nics_later_response_cancelled_date" style="max-width: 13em;" />
				</div>
				<div v-else>
					<checkbox label="Canceled" style="margin: 0.5em 0;" v-model="form.form_data.section_c.nics_later_response_canceled"/>
					<input v-show="form.form_data.section_c.nics_later_response_canceled" type="date" v-model="form.form_data.section_c.nics_later_response_canceled_date" style="max-width: 13em;" />
				</div>
				<div>
					<checkbox label="Overturned" style="margin: 0.5em 0;" v-model="form.form_data.section_c.nics_later_response_overturned"/>
					<input v-show="form.form_data.section_c.nics_later_response_overturned" type="date" v-model="form.form_data.section_c.nics_later_response_overturned_date" style="max-width: 13em;" />
				</div>
			</div>
			<div class="one-two-columns" style="margin: 0 0 1em 0;">
				<checkbox v-model="form.form_data.section_c.nics_later_response_no_response" label="No response was provided within 3 business days."/>
				<checkbox v-model="form.form_data.section_c.nics_later_response_no_response_after_additional_delay" label="No response was provided within 10 business days after additional delay for transferee/buyer under 21 years of age."/>
			</div>
			<div class="four-columns" style="grid-template-columns: 1fr 15em 11em 0.66fr; margin: 0 0 1em 0;">
				<checkbox v-model="form.form_data.section_c.nics_additional_delay" label="Notice of additional delay of transferee under 21 years of age received on"/>
				<input type="date" v-model="form.form_data.section_c.nics_additional_delay_date" style="max-width: 13em;" />
				<div class="label" >Transfer of the firearm may occur on (optional)</div>
				<input type="date" v-model="form.form_data.section_c.nics_additional_delay_transfer_date" style="max-width: 13em;" />
			</div>

			<div style="margin: 0 0 1em 0;">
				<h2 class="small">No NICS check is required</h2>
				<checkbox v-model="form.form_data.section_c.nics_buyer_background_check" label="No NICS check is required because a background check was completed during the NFA approval process on the individual who will receive the NFA firearm(s), as reflected on the approved NFA application." style="margin: 0.5em 0;"/>
				<checkbox v-model="form.form_data.section_c.nics_buyer_exempt" label="No NICS check is required because the transferee/buyer has a valid permit from the State where the transfer is to take place, which qualifies as an exemption to NICS." style="margin: 0.5em 0;"/>
			</div>

			<div class="four-columns">
				<div>
					<label ref="nics_buyer_exempt_permit_state_type">Issuing State and Permit Type</label>
					<input type="text" v-model="form.form_data.section_c.nics_buyer_exempt_permit_state_type"/>
				</div>
				<div>
					<label ref="nics_buyer_exempt_permit_date_issuance">Date of Issuance (if any)</label>
					<!-- <date-input v-model="form.form_data.section_c.nics_buyer_exempt_permit_date_issuance" style="max-width: 13em;" /> -->
					<input type="text" v-model="form.form_data.section_c.nics_buyer_exempt_permit_date_issuance" style="max-width: 13em;"/>
				</div>
				<div>
					<label ref="nics_buyer_exempt_permit_date_expiration">Expiration Date (if any)</label>
					<!-- <date-input v-model="form.form_data.section_c.nics_buyer_exempt_permit_date_expiration" style="max-width: 13em;" :allowFuture="true" /> -->
					<input type="text" v-model="form.form_data.section_c.nics_buyer_exempt_permit_date_expiration" style="max-width: 13em;"/>
				</div>
				<div>
					<label ref="nics_buyer_exempt_permit_number">Permit Number (if any)</label>
					<input type="text" v-model="form.form_data.section_c.nics_buyer_exempt_permit_number" />
				</div>
			</div>

			<div style="margin: 0 0 1em 0;">
				<h2 class="small">After the firearm was transferred, the following response was provided by NICS or the appropriate State agency (if applicable) on:</h2>
				<div class="two-one-columns">
					<div style="margin: 0.5em 0 0 0;">
						<binary-toggle v-model="form.form_data.section_c.nics_after_transfer_response" :tertiary="true" :values="isLegacyData ? 'Proceed,Denied,Cancelled' : 'Proceed,Denied,Canceled'" :labels="isLegacyData ? 'Proceed,Denied,Cancelled' : 'Proceed,Denied,Canceled'" :key="'nat_' + form.form_data.section_c.nics_after_transfer_response"/>
					</div>
					<div>
						<input type="date" v-model="form.form_data.section_c.nics_after_transfer_response_date" style="max-width: 13em; margin: 0.25em 0 0 0;" />
					</div>
				</div>
				<div v-if="locked" class="one-four-columns" style="margin: 0.5em 0 0 0; grid-template-columns: 3em 1fr;">
					<div><div class="button neutral inline" @click="saveAfterTransferResponse()">Save</div></div>
					<label class="inline">You may save "after the firearm was transferred"<br>even after signing Section E.</label>
				</div>
			</div>

		</div>

		<div v-if="nicsOnlineCheck || nicsPhoneCheck" class="modal medium-modal">
			<div class="inner">
				<h2>NICS {{  nicsOnlineCheck ? 'Online' : 'Phone' }} Check</h2>
				<div class="content">
					<div style="margin: 0 0 1em 0;">
						<h3>Customer Contact</h3>
						<div class="two-columns">
							<div>
								<label>Phone Number</label>
								<input type="text" v-model="contactData.phone_number">
							</div>
							<div>
								<label>Email Address</label>
								<input type="text" v-model="contactData.email_address">
							</div>
						</div>
						<div class="three-one-columns">
							<label v-if="message">{{ message }}</label>
							<label v-else-if="contactData.phone_number || contactData.email_address">Your customer's phone number or email address allows you to contact them<br>if the background check response is not immediately available.</label>
							<label v-else>Save your customer's phone number or email address to contact them<br>if the background check response is not immediately available.</label>
							<div :class="['button', contactData.phone_number || contactData.email_address ? 'neutral' : 'disabled', 'small']" @click="saveContact()">
								{{ contactData.phone_number || contactData.email_address ? 'Update' : 'Save' }}
							</div>
						</div>
					</div>
					<div v-show="!fillNicsFormChecked">
						<h3>Transaction Purpose</h3>
						<div class="two-columns">
							<div>
								<checkbox label="Sale of Hand Gun" v-model="customerTransPurpose.l1" class="v-spaced"/>
								<checkbox label="Sale of Long Gun" v-model="customerTransPurpose.l2" class="v-spaced"/>
								<checkbox label="Sale of Other (Frame, Receiver, etc.)" v-model="customerTransPurpose.l3" class="v-spaced"/>
								<checkbox label="Pre-pawn of Hand Gun" v-model="customerTransPurpose.l4" class="v-spaced"/>
								<checkbox label="Pre-pawn of Long Gun" v-model="customerTransPurpose.l5" class="v-spaced"/>
								<checkbox label="Pre-pawn of Other (Frame, Receiver, etc.)" v-model="customerTransPurpose.l6" class="v-spaced"/>
								<checkbox label="Redemption of Hand Gun" v-model="customerTransPurpose.l7" class="v-spaced"/>
								<checkbox label="Redemption of Long Gun" v-model="customerTransPurpose.l8" class="v-spaced"/>
								<checkbox label="Redemption of Other (Frame, Receiver, etc.)" v-model="customerTransPurpose.l9" class="v-spaced"/>
							</div>
							<div>
								<checkbox label="Private Sale of Hand Gun" v-model="customerTransPurpose.l10" class="v-spaced"/>
								<checkbox label="Private Sale Long Gun" v-model="customerTransPurpose.l11" class="v-spaced"/>
								<checkbox label="Private Sale Other" v-model="customerTransPurpose.l12" class="v-spaced"/>
								<checkbox label="Private Sale Returned to Seller Hand Gun" v-model="customerTransPurpose.l13" class="v-spaced"/>
								<checkbox label="Private Sale Returned to Seller Long Gun" v-model="customerTransPurpose.l14" class="v-spaced"/>
								<checkbox label="Private Sale Returned to Seller Other" v-model="customerTransPurpose.l15" class="v-spaced"/>
							</div>
						</div>
					</div>
					<div v-show="!nicsPhoneCheck && !fillNicsFormChecked" style="margin: 1em 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
						<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
						<div style="text-align: left; line-height: 1.5em;">
							Click CONTINUE to open the FBI NICS website in a new window, then...<br>
							1) Log in using your LEEP username and password.<br>
							2) Click "Submit a Search Request - E.C." and check "Yes" in the FFL Verification section.<br>
							4) Use the TRANSFER 4473 DATA button at the top of the LEEP site to copy data on each screen.<br>
							5) Use the COPY RESPONSE button at the top of the LEEP site to record the NICS response.<br>
							6) Then, come <b>back to this window</b> to add the NICS response to this 4473.
						</div>
					</div>

					<div v-show="fillNicsFormChecked">
						<div style="margin: 1em 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
							<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
							<div style="text-align: left; line-height: 1.5em;">
								Info from this 4473 should now be on the FBI NICS page.<br>
								Remember, you are soley responsible for the accuracy of your submission.<br>
								Please check all fields carefully before submitting your NICS check.<br>
								After submitting your NICS check, come <b>back to this window</b><br>where you should see the NTN Number and Initial Response.<br>
							</div>
						</div>

						<div class="two-columns" style="margin: 1em 0;">
							<label>NTN Number</label>
							<label>Initial Response</label>
							<input type="text" v-model="form.nics_number">
							<input type="text" v-model="form.form_data.section_c.nics_initial_response">
						</div>
						<div v-if="form.nics_number">
							Remember to save Section C now that you have the NTN Number.
						</div>
						<div v-else>
							Don't see the NTN Number and Initial Response? You can copy and paste them from the FBI NICS page.
						</div>

					</div>

					<div v-if="nicsPhoneCheck">
						<div class="small" style="float: right;">Scroll for all phone check info<br>and to enter result.</div>
						<h3>Customer Info</h3>
						<div class="search-list">
							<div class="one-two-columns list-item v-spaced"><label>Customer Name</label><span>{{ form.form_data.section_b.last_name }} {{ form.form_data.section_b.first_name }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>First Name</label><span>{{ form.form_data.section_b.first_name }}<template v-if="form.form_data.section_b.first_initial">IO</template></span></div>
							<div class="one-two-columns list-item v-spaced"><label>Middle Name</label><span v-if="form.form_data.section_b.no_middle_name">NMN</span><span v-else>{{ form.form_data.section_b.middle_name }}<template v-if="form.form_data.section_b.middle_initial">   IO</template></span></div>
							<div class="one-two-columns list-item v-spaced"><label>Last Name</label><span>{{ form.form_data.section_b.last_name }}<template v-if="form.form_data.section_b.last_initial">IO</template></span></div>
							<div class="one-two-columns list-item v-spaced"><label>Suffix</label><span>{{ form.form_data.section_b.suffix }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Height</label><span>{{ form.form_data.section_b.feet }}'{{ form.form_data.section_b.inches }}''</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Weight</label><span>{{ form.form_data.section_b.weight }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Gender</label><span v-if="form.form_data.section_b.gender_code == 'U'">Non-Binary</span><span v-else>{{ form.form_data.section_b.gender_code }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Date of Birth</label><span>{{ $moment(form.form_data.section_b.birthdate).format('MM/DD/YYYY') }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Place of Birth</label><span>{{ form.form_data.section_b.pob_code || form.form_data.section_b.foreign_country }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Ethnicity</label><span>{{ form.form_data.section_b.ethnicity }}</span></div>
							<div v-if="form.form_data.section_b.use_new_race_list" class="one-two-columns list-item v-spaced"><label>Race Code</label>
								<span v-if="form.form_data.section_b.customer_race.l4 != ''">American Indian or Alaskan Native </span>
								<span v-if="form.form_data.section_b.customer_race.l1 != ''">Asian </span>
								<span v-if="form.form_data.section_b.customer_race.l2 != ''">Black or African American </span>
								<span v-if="form.form_data.section_b.customer_race.l6 != ''">Native Hawaiian or Other Pacific Islander </span>
								<span v-if="form.form_data.section_b.customer_race.l7 != ''">White </span>
								<span v-if="form.form_data.section_b.customer_race.l5 != ''">Middle Eastern/North African </span>
							</div>
							<div v-else class="one-two-columns list-item v-spaced"><label>Race Code</label>
								<span v-if="form.form_data.section_b.customer_race.l4 != ''">American Indian or Alaskan Native </span>
								<span v-if="form.form_data.section_b.customer_race.l1 != ''">Asian </span>
								<span v-if="form.form_data.section_b.customer_race.l2 != ''">Black or African American </span>
								<span v-if="form.form_data.section_b.customer_race.l5 != ''">Native Hawaiian or Other Pacific Islander </span>
								<span v-if="form.form_data.section_b.customer_race.l6 != ''">White </span>
							</div>
							<div class="one-two-columns list-item v-spaced"><label>State</label><span>{{ form.form_data.section_b.state }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>Citizenship</label>
								<span v-if="form.form_data.section_b.citizen_status_code == 'C'">US Citizen</span>
								<ul v-else class="citizenship-country-list">
									<li v-if="form.form_data.section_b.citizen_country_code">{{ form.form_data.section_b.citizen_country_code }}</li>
									<li v-if="form.form_data.section_b.citizen_country_code_2">{{ form.form_data.section_b.citizen_country_code_2 }}</li>
									<li v-if="form.form_data.section_b.citizen_country_code_3">{{ form.form_data.section_b.citizen_country_code_3 }}</li>
								</ul></div>
							<div class="one-two-columns list-item v-spaced"><label>ID Issuing Authority</label><span>{{ form.form_data.section_c.buyer_identification_issuing_authority_and_type }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>ID Type</label><span>{{ form.form_data.section_c.buyer_identification_type_code }}</span></div>
							<div class="one-two-columns list-item v-spaced"><label>ID Number</label><span>{{ form.form_data.section_c.buyer_identification_number }}</span></div>
							<div v-if="form.form_data.section_c.buyer_identification_expiration_date" class="one-two-columns list-item v-spaced"><label>ID Expiration</label><span>{{ $moment(form.form_data.section_c.buyer_identification_expiration_date).format('MM/DD/YYYY') }}</span></div>
							<div v-if="form.form_data.section_b.ssn" class="one-two-columns list-item v-spaced"><label>Social Security Number</label><span>{{ form.form_data.section_b.ssn }}</span></div>
						</div>

						<div style="margin: 1em 0;">
							<h3>NICS Response</h3>
							<div class="three-columns">
								<label>NTN Number</label>
								<label>FBI Status</label> 
								<label>Date</label>
								<input type="text" v-model="form.nics_number">
								<select v-model="form.form_data.section_c.nics_initial_response">
									<option value="">Select one...</option>
									<option value="Researching">Researching</option>
									<option value="Proceed">Proceed</option>
									<option value="Denied">Denied</option>
									<option value="Delayed">Delayed</option>
									<option v-if="isLegacyData" value="Cancelled">Canceled</option>
									<option v-else value="Canceled">Canceled</option>
								</select>
								<input type="date" v-model="form.form_data.section_c.nics_initial_response_date"/>
							</div>
						</div>
					</div>
				</div>

				<div v-if="nicsOnlineCheck" class="controls">
					<div class="button cancel spaced" @click="nicsOnlineCheck = false">Cancel</div>
					<div v-if="!fillNicsFormChecked" :class="['button', customerTransPurposeEmpty ? 'disabled' : 'action', 'spaced']" @click="handleFillNicsForm()">Continue</div>
					<div v-if="fillNicsFormChecked" :class="['button', form.nics_number ? 'action' : 'disabled', 'spaced']" @click="nicsOnlineCheck = false">Finished</div>
				</div>

				<div v-if="nicsPhoneCheck" class="controls">
					<div class="button cancel spaced" @click="nicsPhoneCheck = false">Cancel</div>
					<div :class="['button', form.nics_number ? 'action' : 'disabled', 'spaced']" @click="nicsPhoneCheck = false">Finished</div>
				</div>

			</div>
		</div>

		<div v-if="locked" style="position: absolute; top: 2.5em; left: 0; width: 100%; height: calc(100% - 10.5em); cursor: not-allowed;" @click="showLockedReason()"></div>

		<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	</div>
</template>

<script>
import BinaryToggle from '@/components/BinaryToggle.vue'
import Checkbox from '@/components/Checkbox.vue'
import DateInput from '@/components/DateInput.vue'
export default {
	name: 'form4473-section-c',
	props: ['form', 'contactData', 'locked'],
	components: {
		'binary-toggle': BinaryToggle,
		'checkbox': Checkbox,
		'date-input': DateInput
	},
	data() {
		return {
			loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
            nicsOnlineCheck: false,
            nicsPhoneCheck: false,
			fillNicsFormChecked: false,
			customerTransPurpose: {},
			saving: false,
			today: '',
			acceptDelayedDateSectionC: false,
		}
	},
	mounted() {
		// console.log('PROCEED'.capitalizeWords())
        // listen for nics response
        window.addEventListener('nics_response_to_form', (e) => {
            this.form.form_data.section_c.nics_initial_response = e.detail.nics_initial_response.capitalizeWords()
            this.form.nics_number = e.detail.nics_number
            this.form.form_data.section_c.nics_initial_response_date = this.$moment().format('YYYY-MM-DD')
        })
	},
	created() {
		let theDate = new Date()
		this.today = theDate.getFullYear() + '-' + (theDate.getMonth() + 1).toString().padStart(2,'0') + '-' + theDate.getDate().toString().padStart(2,'0')
	},
	computed: {
		customerTransPurposeEmpty() {
			return (Object.values(this.customerTransPurpose).every(x => x === null && x === ''))
		},
		readyForNICSCheck() {
			if (this.locked) { return false }
			if (!this.form.form_data.section_c.buyer_identification_issuing_authority_and_type) { return false }
			if (!this.form.form_data.section_c.buyer_identification_type_code) { return false }
			if (!this.form.form_data.section_c.buyer_identification_number) { return false }
			return true
		},
		isLegacyData(){
			if (this.form.form_data.section_c.nics_initial_response == 'Cancelled') return true
			if (this.form.form_data.section_c.nics_later_response_cancelled) return true
			if (this.form.form_data.section_c.nics_after_transfer_response == 'Cancelled') return true
			return false
		},
	},
	watch: {
		'acceptDelayedDateSectionC' (newVal) {
			if (newVal) {
				// delayed needs to be the first weekday after three weekdays after the current date
				// https://gist.github.com/psdtohtml5/7000529
				let addDays = 4
				let today = new Date()
			    let d = new Date(today.getTime())
			    let day = d.getDay()
			    d.setDate(d.getDate() + addDays + (day === 6 ? 2 : +!day) + (Math.floor((addDays - 1 + (day % 6 || 1)) / 5) * 2))
				this.form.form_data.section_c.nics_firearm_may_be_transferred = this.$moment(d).format('YYYY-MM-DD');
			} else {
				this.form.form_data.section_c.nics_firearm_may_be_transferred = ''
			}
		},
		"form.form_data.section_c.nics_additional_delay" (newVal) {
			if (!newVal) {
				this.form.form_data.section_c.nics_additional_delay_transfer_date = ''
				this.form.form_data.section_c.nics_additional_delay_date = ''
			}
		},
		// clear delayed date if option changed
		"form.form_data.section_c.nics_initial_response"(newVal, oldVal) {
			if (newVal !== 'Delayed' && oldVal === 'Delayed') {
				this.form.form_data.section_c.nics_firearm_may_be_transferred = ''
				this.acceptDelayedDateSectionC = false
			}
		}
	},
    methods: {
        countryCodeFromName(countryName) {
            if (!countryName) { return '' }
            return Object.keys(this.COUNTRIES_LIST).find(key => this.COUNTRIES_LIST[key] === countryName)
        },
		handleFillNicsForm() {

			// No dashes allowed
			if (this.form.form_data.section_b.ssn) {
				this.form.form_data.section_b.ssn = this.form.form_data.section_b.ssn.replace(/-/gi, '')
			}
			if (this.form.form_data.section_b.mnu1) {
				this.form.form_data.section_b.mnu1 = this.form.form_data.section_b.mnu1.replace(/-/gi, '')
			}
			if (this.form.form_data.section_c.buyer_identification_number) {
				this.form.form_data.section_c.buyer_identification_number = this.form.form_data.section_c.buyer_identification_number.replace(/-/gi, '')
			}

			//let foreignCountryCode = this.form.form_data.section_b.foreign_country
			// FBI likes country abbreviations, so derive from country name
			let foreignCountryCode = ''
			if (this.form.form_data.section_b.foreign_country) {
				foreignCountryCode = Object.keys(this.COUNTRIES_LIST).find(key => this.COUNTRIES_LIST[key] === this.form.form_data.section_b.foreign_country)
			}

			let formInfo = {
				cds_first_name: this.form.form_data.section_b.first_name,
				cds_last_name: this.form.form_data.section_b.last_name,
				cds_middle_name: (this.form.form_data.section_b.no_middle_name) ? 'NMN' : this.form.form_data.section_b.middle_name,
				cds_initial_only: !this.form.form_data.section_b.no_middle_name && this.form.form_data.section_b.middle_initial,
				cds_no_middle_name: this.form.form_data.section_b.no_middle_name,
				cds_cadence_code: this.form.form_data.section_b.suffix.toUpperCase(),
				cds_address_1: this.form.form_data.section_b.address_1,
				cds_city: this.form.form_data.section_b.city,
				cds_state_code: this.form.form_data.section_b.state,
				cds_zip_code: this.form.form_data.section_b.zip_code,
				cds_county: this.form.form_data.section_b.county,
				cds_pob_code: (this.form.form_data.section_b.pob_code != '') ? this.form.form_data.section_b.pob_code : foreignCountryCode,
				cds_height: this.form.form_data.section_b.feet.toString() + this.form.form_data.section_b.inches.toString().padStart(2, "0"),
				cds_weight: this.form.form_data.section_b.weight,
				cds_gender_code: this.form.form_data.section_b.gender_code,
				cds_dob: this.$moment(this.form.form_data.section_b.birthdate).format('YYYYMMDD'),
				cds_ssn: this.form.form_data.section_b.ssn,
				cds_upin_amd_id: this.form.form_data.section_b.upin,
				cds_is_hispanic_or_latino: this.form.form_data.section_b.ethnicity == 'hispanic',
				cds_customer_race_l1: this.form.form_data.section_b.customer_race['l1'],
				cds_customer_race_l2: this.form.form_data.section_b.customer_race['l2'],
				cds_customer_race_l4: this.form.form_data.section_b.customer_race['l4'],
				cds_customer_race_l5: this.form.form_data.section_b.customer_race['l5'],
				cds_customer_race_l6: this.form.form_data.section_b.customer_race['l6'],
				cds_customer_race_l7: this.form.form_data.section_b.customer_race['l7'],
				cds_citizen_status_code: this.form.form_data.section_b.citizen_status_code,
				cds_citizen_country_code: this.countryCodeFromName(this.form.form_data.section_b.citizen_country_code),
				cds_citizen_country_code_2: (this.form.form_data.section_b.citizen_country_code_2) ? this.countryCodeFromName(this.form.form_data.section_b.citizen_country_code_2) : '',
				cds_citizen_country_code_3: (this.form.form_data.section_b.citizen_country_code_3) ? this.countryCodeFromName(this.form.form_data.section_b.citizen_country_code_3) : '',
				cds_exc_code: (this.form.form_data.section_b.exc_code) ? ((this.form.form_data.section_b.exc_code == 'yes') ? 'Y' : 'N') : '',
				cds_customer_trans_purpose_l1: this.customerTransPurpose['l1'],
				cds_customer_trans_purpose_l2: this.customerTransPurpose['l2'],
				cds_customer_trans_purpose_l3: this.customerTransPurpose['l3'],
				cds_customer_trans_purpose_l4: this.customerTransPurpose['l4'],
				cds_customer_trans_purpose_l5: this.customerTransPurpose['l5'],
				cds_customer_trans_purpose_l6: this.customerTransPurpose['l6'],
				cds_customer_trans_purpose_l7: this.customerTransPurpose['l7'],
				cds_customer_trans_purpose_l8: this.customerTransPurpose['l8'],
				cds_customer_trans_purpose_l9: this.customerTransPurpose['l9'],
				cds_customer_trans_purpose_l10: this.customerTransPurpose['l10'],
				cds_customer_trans_purpose_l11: this.customerTransPurpose['l11'],
				cds_customer_trans_purpose_l12: this.customerTransPurpose['l12'],
				cds_customer_trans_purpose_l13: this.customerTransPurpose['l13'],
				cds_customer_trans_purpose_l14: this.customerTransPurpose['l14'],
				cds_customer_trans_purpose_l15: this.customerTransPurpose['l15'],
				cds_mnu: this.form.form_data.section_c.buyer_identification_type_code,
				cds_mnu_value: this.form.form_data.section_c.buyer_identification_number
			}
			// For middle_name there are checkboxes for IO and NMN
            // not so for first/last names so we just tack those on to the end if needed
            formInfo.LAST_NAME += (this.form.form_data.section_b.last_initial) ? " IO" : ""
			formInfo.FIRST_NAME += (this.form.form_data.section_b.first_initial) ? " IO" : ""

			if (this.form.form_data.section_b.mnu1) {
				formInfo.cds_mnu1 = this.form.form_data.section_b.mnu_type_code1,
				formInfo.cds_mnu1_value = this.form.form_data.section_b.mnu1.charAt(0) == 'A' ? this.form.form_data.section_b.mnu1.substring(1) : this.form.form_data.section_b.mnu1
			}

			console.log(formInfo)
            // return false

			window.formInfo = formInfo
			var event = new CustomEvent('nics_data', { detail: formInfo });
			window.dispatchEvent(event);
			this.fillNicsFormChecked = true;
			window.addEventListener('nics_data_saved', () => {
				window.open("https://www.cjis.gov/")
				//this.nicsOnlineCheck = false
			})
		},
        saveOnlineNTNStatus() {
			console.log('saving LEEP response!')
			this.form.nics_number = nics_number.value
			this.form.form_data.section_c.nics_initial_response = nics_initial_response.value
			this.form.form_data.section_c.nics_initial_response_date = this.$moment().format('YYYY-MM-DD')
			this.nicsOnlineCheck = false
			//this.$refs['nics_check'].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
		},
		validateSection() {
			for (const [key, element] of Object.entries(this.$refs)) {
				this.removeError(element)
			}
			let data = this.form.form_data.section_c
			let errorMessage = ''
			// require inputs
			if (Object.values(data.customer_trans_purpose).every(x => x === null || x === '')) {
				this.applyError(this.$refs.customer_trans_purpose)
				errorMessage = this.$refs.customer_trans_purpose.textContent
				return errorMessage
			}
            if (data.buyer_identification_type_code == 'DL') {
                if (!data.buyer_identification_expiration_date) {
    				this.applyError(this.$refs.buyer_identification_expiration_date)
	    			errorMessage = 'Expiration date is required for drivers license'
		    		return errorMessage
                }
            }

		},
		applyError(element) {
			element.classList.add("please-correct")
			element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
		},
		removeError(element) {
			if (!element || typeof element == 'undefined') { return }
			element.classList.remove("please-correct")
		},
		saveContact() {
			if (this.saving) { return }
            if (!this.contactData.phone_number || !this.contactData.email_address) { return }
			this.saving = true
			this.message = 'Saving customer contact info...'
            this.apiCall({ destination: 'save_item_contact', data: this.contactData }).then(obj => {
				this.saving = false
                if (obj.status == 'success') {
					this.message = 'Customer contact info has been saved!'
					this.messageTimeout = 2000
				} else {
					this.messageStatus = 'error'
                    this.message = obj.message
                }
            }).catch(err => {
                console.log(err);
            })
		},
		saveAfterTransferResponse() {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Saving after transfer response...'
			let postData = {
				ffl_log_book_form_id: this.form.ffl_log_book_form_id,
				nics_after_transfer_response: this.form.form_data.section_c.nics_after_transfer_response,
				nics_after_transfer_response_date: this.form.form_data.section_c.nics_after_transfer_response_date
			}
            this.apiCall({ destination: 'save_item_after_transfer_response', data: postData }).then(obj => {
				this.saving = false
                if (obj.status == 'success') {
					this.message = 'After transfer response has been saved!'
					this.messageTimeout = 2000
				} else {
					this.messageStatus = 'error'
                    this.message = obj.message
                }
            }).catch(err => {
                console.log(err);
            })
		},
		showLockedReason() {
			this.message = 'Section C is locked because<br>'
			if (this.form.internal_use_only == 2) {
				this.message += 'this form is awaiting correction by the customer.'
			} else if (this.form.moved_to_ffl_log_book_form_id) {
				this.message += 'it is a previous version of a corrected form.'
			} else if (this.form.form_data.section_e.seller_signature) {
				this.message += 'Section E has been signed.'
			} else {
				this.message += 'previous required sections have not been completed.'
			}
			this.messageStatus = 'alert'
		}
    }
}
</script>
